import React, { useEffect } from "react";
import Section from "./Section";
import NavTabs from "@components/NavTabs/NavTabs";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";

function ByLocation({
  account_slug,
  project_id,
  projectServices,
  projectSubservices,
  resources,
  projectResources,
  lobs,
  projectLocations,
  isLoading,
  rateType,
}) {
  useEffect(() => {}, [isLoading]);

  return (
    <>
      <NavTabs
        tabOneText="By LOB"
        tabOneUrl={`/projects/${project_id}/summary`}
        tabTwoText="By Phase"
        tabTwoUrl={`/projects/${project_id}/summary/phase`}
        tabThreeText={projectLocations.length >= 2 ? "By Location" : null}
        tabThreeUrl={`/projects/${project_id}/summary/location`}
      />
      <div className="col-sm-12" id="sow-workarea">
        {isLoading ? (
          <div style={{ paddingTop: "15px" }}>
            <ScopeStackSpinner />
          </div>
        ) : (
          <Section
            array={projectLocations}
            projectServices={projectServices}
            projectSubservices={projectSubservices}
            relationshipName="project-location"
            resources={projectResources}
            rateType={rateType}
            lobs={lobs}
          />
        )}
      </div>
    </>
  );
}

export default ByLocation;
